/*
  /pages/audit · decision-first hero. The visitor picks a revenue band, sees the matching tier, and buys it in one tap.
  Without JavaScript the Starter checkout link still works. Deep link: ?tier=starter|growth|scale|enterprise.
  Analytics: pushes audit_tier_select and audit_cta_click to window.dataLayer.
*/
(function () {
  'use strict';

  var root = document.getElementById('get-audit');
  if (!root) return;

  var radios = Array.prototype.slice.call(root.querySelectorAll('input[name="ah-tier"]'));
  var cta = root.querySelector('[data-ah-cta]');
  var talk = root.querySelector('[data-ah-talk]');
  var mobile = document.querySelector('.mobile-cta a');
  var dataLayer = (window.dataLayer = window.dataLayer || []);

  function slots(key) { return root.querySelectorAll('[data-ah="' + key + '"]'); }

  function set(key, text) {
    Array.prototype.forEach.call(slots(key), function (node) { node.textContent = text; });
  }

  function current() {
    for (var i = 0; i < radios.length; i++) if (radios[i].checked) return radios[i];
    return radios[0];
  }

  function render(input) {
    var d = input.dataset;
    set('name', d.name);
    set('price', d.price);
    set('f1', d.f1);
    set('f2', d.f2);
    set('f3', d.f3);
    set('cta', d.cta);
    set('start', d.start);
    cta.href = d.url;
    if (talk) talk.hidden = input.value !== 'enterprise';
    if (mobile) {
      mobile.href = d.url;
      mobile.setAttribute('target', '_top');
      mobile.innerHTML = '<span>' + d.cta + ' · <span class="price">' + d.price + '</span></span><span class="arrow-i" aria-hidden="true"></span>';
    }
  }

  function track(event, extra) {
    var d = current().dataset;
    var payload = { event: event, audit_tier: current().value, audit_price: d.price };
    for (var k in extra) payload[k] = extra[k];
    dataLayer.push(payload);
  }

  radios.forEach(function (input) {
    input.addEventListener('change', function () {
      render(input);
      track('audit_tier_select');
    });
  });

  cta.addEventListener('click', function () { track('audit_cta_click', { cta_position: 'hero' }); });
  if (mobile) mobile.addEventListener('click', function () { track('audit_cta_click', { cta_position: 'sticky_mobile' }); });
  if (talk) talk.addEventListener('click', function () { track('audit_cta_click', { cta_position: 'hero_talk_to_jake' }); });

  var wanted = (new URLSearchParams(window.location.search).get('tier') || '').toLowerCase();
  radios.forEach(function (input) { if (input.value === wanted) input.checked = true; });

  render(current());
})();
